import React from "react";
import { useTranslation } from "react-i18next";

interface RiskContextIndicatorProps {
  selectedRiskTitle?: string;
  visible: boolean;
  enabled?: boolean; // Easy toggle to show/hide the entire component
}

export const RiskContextIndicator: React.FC<RiskContextIndicatorProps> = ({
  selectedRiskTitle,
  visible,
  enabled = true,
}) => {
  const { t } = useTranslation("ui");
  // Easy way to completely disable the component
  if (!enabled) return null;

  if (!visible || !selectedRiskTitle) return null;

  return (
    <div
      className="bg-gray-300 border-gray-200 mb-0 rounded-t-xl border shadow-sm"
      style={{
        zIndex: 10,
        backgroundColor: "#fafafa",
        position: "relative",
      }}
    >
      <div className="p-3">
        <div className="text-gray-900 text-xs leading-4 tracking-[0.04px]">
          <span className="font-normal">
            {t("intro.riskContextIndicator.askingAbout")}{" "}
          </span>
          <span className="font-bold">{selectedRiskTitle}</span>
        </div>
      </div>
    </div>
  );
};
